<span class="status-badge" [ngClass]="'status-badge--' + config.key">
  <i [class]="config.icon"></i>
  {{ config.label }}
</span>
